module.exports = __webpack_public_path__ + "img/ctrl-ry-stub-+.3afe79c3.svg";